export default __webpack_public_path__ + "4c3ac6f2f947cbc6744904426d4d8c3f.png";